@import './pk-card-media.variables';

:host {
  @apply block;
}

.card-media {
  @apply flex flex-col rounded-[--card-media--rounded] bg-[color:--card-media--background] p-m;
  @apply transition-[shadow,background-color] duration-250;
  box-shadow: var(--card-media--shadow);

  &:hover {
    @apply hover:bg-[color:--card-media--background-hover];
    box-shadow: var(--card-media--shadow-hover);
  }
}

.card-media__thumbnail {
  @apply bg-transparent;

  &.aspect-video {
    @apply max-w-[--card-media--thumb-video-width-mobile] sm:max-w-[--card-media--thumb-video-width];
  }

  &.aspect-square {
    @apply max-w-[--card-media--thumb-square-width-mobile] sm:max-w-[--card-media--thumb-square-width];
  }

  &.aspect-custom {
    @apply h-[--card-media--thumb-height] w-[--card-media--thumb-width];
  }
}

.card-media__thumbnail--img {
  &.aspect-video {
    @apply aspect-h-9 aspect-w-16;
  }

  &.aspect-square {
    @apply aspect-h-1 aspect-w-1;

    ::slotted(*) {
      @apply h-[--card-media--thumb-square-width-mobile] w-[--card-media--thumb-square-width-mobile] sm:h-[--card-media--thumb-square-width] sm:w-[--card-media--thumb-square-width];
    }
  }

  &.aspect-custom {
    @apply h-[--card-media--thumb-height] w-[--card-media--thumb-width];
  }

  ::slotted(*) {
    @apply h-full w-full rounded-[--card-media--rounded-mobile] object-cover sm:rounded-[--card-media--rounded];
  }
}

.card-media__content--title {
  ::slotted(*) {
    @apply m-0 font-semibold text-m leading-m text-text-01 sm:text-l;
  }
}

.card-media__content--body {
  ::slotted(*) {
    @apply p-0 font-regular text-s text-text-02;
  }
}
